var styles = {"box":"BasePopup_box_pm8fg_1","box__inner":"BasePopup_box__inner_pm8fg_6","horizontalLeftOut":"BasePopup_horizontalLeftOut_pm8fg_1","horizontalLeftIn":"BasePopup_horizontalLeftIn_pm8fg_1","medium":"BasePopup_medium_pm8fg_17","small":"BasePopup_small_pm8fg_20","primary":"BasePopup_primary_pm8fg_23","outline":"BasePopup_outline_pm8fg_29"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
